import { useQuery } from "@tanstack/react-query";
import { fetchMicroAppContent } from "@/api";

/** A micro-app's HTML content, fetched via the src/api seam (text/html). */
export function useMicroAppContent(uuid: string) {
  return useQuery({
    queryKey: ["microAppContent", uuid],
    queryFn: () => fetchMicroAppContent(uuid),
    staleTime: 0, // ETag revalidation on every load; content changes on republish.
  });
}
